/**
 * Central user display-name resolution (do not use email as the primary name).
 */

export function resolveUserDisplayName(user, options = {}) {
  const { fallback = "—", allowEmailFallback = false } = options;
  if (!user) return fallback;

  const full = String(user.fullName || user.displayName || user.name || "").trim();
  if (full) return full;

  const fromParts = [user.firstName, user.lastName]
    .map((p) => (p != null ? String(p).trim() : ""))
    .filter(Boolean)
    .join(" ")
    .trim();
  if (fromParts) return fromParts;

  if (allowEmailFallback) {
    const email = String(user.email || "").trim();
    if (email) return email;
  }

  return fallback;
}

export function resolveUserEmail(user) {
  return String(user?.email || "").trim();
}
